import {useContext, useEffect, useState} from "react";
import {formatCurrency, getPreferenceValue} from "../../common/Utils";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import MDInput from "../../../components/MDInput";
import Checkbox from "@mui/material/Checkbox";
import {DesktopDatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import {ButtonGroup, Divider} from "@mui/material";
import MDButton from "../../../components/MDButton";
import {Col, Row} from "react-bootstrap";
import {CompanyContext} from "../../../lib/CompanyProvider";

export default function CartGiftCard({inventory, giftCardRecipientCallback, formCallback}) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);
  const [giftCardStep, setGiftCardStep] = useState(1);
  const [giftCardAmount, setGiftCardAmount] = useState(inventory?.minAmount || 0);
  const [formInvalid, setFormInvalid] = useState(false);
  const [giftCardRecipientName, setGiftCardRecipientName] = useState();
  const [giftCardRecipientEmail, setGiftCardRecipientEmail] = useState();
  const [giftCardRecipientMessage, setGiftCardRecipientMessage] = useState();
  const [giftCardRecipientSendDate, setGiftCardRecipientSendDate] = useState();
  const [giftCardDeliverFuture, setGiftCardDeliverFuture] = useState(false);

  const [prefsReady, setPrefsReady] = useState(false);
  const [smartPercentages, setSmartPercentages] = useState(true);
  useEffect(() => {
    if ('false' !== getPreferenceValue(companyContext?.company?.preferences, 'disable_portal_smart_percentages', 'false')) {
      setSmartPercentages(false);
    }
    setPrefsReady(true);
  }, [companyContext]);

  const GIFT_CARD_INIT = 1;
  const GIFT_CARD_FRIEND = 2;
  const GIFT_CARD_PERSONAL = 3;

  const PRINT_HOME_OPTIONS = {
    CHOOSE: 1,
    YES: 2,
    NO: 3
  }

  const [printAtHome, setPrintAtHome] = useState(PRINT_HOME_OPTIONS.CHOOSE);

  const [giftCardValues, setGiftCardValues] = useState([]);
  const [giftCardPickerSelected, setGiftCardPickerSelected] = useState(0);
  const [giftCardPicker, setGiftCardPicker] = useState(false);


  function getValues(min, max, count = 4) {
    if (count <= 1) return [min];
    if (count === 2) return [min, max];

    const result = [min];
    const interval = (max - min) / (count - 1);

    for (let i = 1; i < count - 1; i++) {
      const value = Math.round((min + interval * i) / 5) * 5;
      if (value !== result[result.length - 1] && value < max) {
        result.push(value);
      }
    }

    result.push(max);

    return result;
  }


  const doGiftCardValues = () => {
    setGiftCardPicker(true);
    if (!smartPercentages) {
      setGiftCardPickerSelected(-1)
    } else {
      let values = getValues(inventory.minAmount, inventory.maxAmount, 4);
      let _vals = [];
      for (let j = 0; j < values.length; j++) {
        _vals.push({
          id: j,
          value: values[j]
        });
      }
      setGiftCardAmount(_vals[0].value);
      setGiftCardValues(_vals);
    }
  }

  useEffect(() => {
    if (!prefsReady || !inventory?.minAmount) {
      return;
    }

    if (inventory?.minAmount !== inventory?.maxAmount) {
      doGiftCardValues();
    }
  }, [prefsReady, inventory?.minAmount])

  useEffect(() => {
    giftCardRecipientCallback({
      giftCardAmount: giftCardAmount,
      giftCardRecipientName: giftCardRecipientName,
      giftCardRecipientEmail: giftCardRecipientEmail,
      giftCardRecipientMessage: giftCardRecipientMessage,
      giftCardRecipientSendDate: giftCardRecipientSendDate,
      giftCardDeliverFuture: giftCardDeliverFuture
    })
  }, [giftCardAmount, giftCardRecipientName, giftCardRecipientEmail, giftCardRecipientMessage, giftCardRecipientSendDate, giftCardDeliverFuture]);

  useEffect(() => {
    if (printAtHome === PRINT_HOME_OPTIONS.YES) {
      setGiftCardRecipientName(null);
      setGiftCardRecipientEmail(null);
      setGiftCardRecipientMessage(null);
      setGiftCardRecipientSendDate(null);
      setGiftCardDeliverFuture(false);
    }
  }, [printAtHome]);

  useEffect(() => {
    setFormInvalid(true);
    if (giftCardStep === GIFT_CARD_INIT) {
      setFormInvalid(true);
      return;
    }
    if (printAtHome === PRINT_HOME_OPTIONS.CHOOSE && giftCardStep !== GIFT_CARD_PERSONAL) {
      setFormInvalid(true);
      return;
    }
    if (giftCardStep === GIFT_CARD_PERSONAL) {
      setFormInvalid(!(giftCardAmount >= inventory?.minAmount));
    }
    if (giftCardStep === GIFT_CARD_FRIEND && printAtHome) {
      setFormInvalid(!(giftCardAmount >= inventory?.minAmount));
    }
    if (giftCardStep === GIFT_CARD_FRIEND && !printAtHome) {
      let valid = setGiftCardRecipientName?.length > 0 && giftCardRecipientEmail?.length > 0 && giftCardAmount >= inventory?.minAmount;
      setFormInvalid(!(valid));
    }
  }, [giftCardStep, printAtHome, giftCardRecipientEmail, setGiftCardRecipientName]);

  useEffect(() => {
    formCallback(!formInvalid)
  }, [formInvalid]);

  return (
    <div style={{
      width: '100%',
      padding: '15px 0'
    }}>

      {giftCardStep === GIFT_CARD_INIT && <>
        <ButtonGroup>
          <MDButton color="primary" className={'mx-1'}
                    onClick={(e) => {
                      setGiftCardStep(GIFT_CARD_PERSONAL);
                    }}>
            Gift Card is For Myself
          </MDButton>

          <MDButton color="primary" className={'mx-1'}
                    onClick={(e) => {
                      setGiftCardStep(GIFT_CARD_FRIEND);
                    }}>
            Gift Card is For a Friend
          </MDButton>

        </ButtonGroup>
      </>}

      {giftCardStep !== GIFT_CARD_INIT && <>
        {inventory?.minAmount === inventory?.maxAmount && <>
          <div style={{
            display: 'block',
            margin: '10px 0'
          }}>
            <h6 htmlFor="name">Price</h6>
            <p>
              {formatCurrency(giftCardAmount)}
            </p>
          </div>
        </>}
        {inventory?.minAmount !== inventory?.maxAmount && <>
          <h6 style={{
            fontWeight: 'bold'
          }}>Gift Card Value</h6>

          {giftCardValues?.length > 0 && <>
            <ButtonGroup style={{marginBottom: '8px'}}>
              {giftCardValues?.map((v) => {
                return (
                  <MDButton style={{
                    background: giftCardPickerSelected === v.id ? '#111' : '#fff',
                    color: giftCardPickerSelected === v.id ? '#fff' : '#111',
                  }} color={'primary'} variant={'outlined'} key={v.id} onClick={() => {
                    setGiftCardAmount(v.value);
                    setGiftCardPickerSelected(v.id);
                  }}>{formatCurrency(v.value)}</MDButton>
                )
              })
              }
              <MDButton
                style={{
                  background: giftCardPickerSelected === -1 ? '#111' : '#fff',
                  color: giftCardPickerSelected === -1 ? '#fff' : '#111',
                }}
                color={'primary'} variant={'outlined'} onClick={() => {
                setGiftCardAmount(inventory.minAmount);
                setGiftCardPickerSelected(-1);
              }}>Other Amount</MDButton>
            </ButtonGroup>
          </>}


          {giftCardPickerSelected === -1 && <Row>
            <Col xs={12}>
              <TextField type="number" required
                         min={inventory?.minAmount}
                         max={inventory?.maxAmount}
                         onChange={(e) => {
                           if (!e.target.value) {
                             setFormInvalid(true);
                             setGiftCardAmount(null);
                             return;
                           }
                           let target = parseFloat(e.target.value);
                           if (target < parseFloat(inventory?.minAmount)) {
                             setFormInvalid(true);
                             setGiftCardAmount(target);
                           } else if (target > parseFloat(inventory?.maxAmount)) {
                             setGiftCardAmount(target);
                             setFormInvalid(true);
                           } else {
                             setFormInvalid(false);
                             setGiftCardAmount(target);
                           }
                         }}

                         InputProps={{
                           startAdornment: <AttachMoneyIcon/>,
                           inputProps: {
                             min: parseFloat(inventory?.minAmount),
                             max: parseFloat(inventory?.maxAmount),
                             step: 0.01
                           }
                         }}

                         value={giftCardAmount || null}
                         autoComplete="off"
                         name="giftCardAmount"
                         className="form-control pull-left" id="giftCardAmount"
                         style={{width: '250px'}}/>
            </Col>
          </Row>}
          <p style={{
            marginTop: '5px',
            clear: 'both'
          }}>Enter gift card value between&nbsp;
            {formatCurrency(inventory?.minAmount)} - {formatCurrency(inventory?.maxAmount)}
          </p>
        </>
        }

        {giftCardStep === GIFT_CARD_FRIEND && <>

          <Row>
            <Col>
              <h5>Choose delivery method</h5>
              <ButtonGroup>
                <MDButton size={'small'} color={'secondary'}
                          disabled={printAtHome === PRINT_HOME_OPTIONS.YES}
                          className={'mx-1'} onClick={() => {
                  setPrintAtHome(PRINT_HOME_OPTIONS.YES);
                }}>Print At Home</MDButton>
                <MDButton size={'small'}
                          disabled={printAtHome === PRINT_HOME_OPTIONS.NO}
                          color={'secondary'} onClick={() => {
                  setPrintAtHome(PRINT_HOME_OPTIONS.NO)
                }}>Email to Friend</MDButton>
              </ButtonGroup>
            </Col>
          </Row>

          {printAtHome === PRINT_HOME_OPTIONS.NO && <Row>

            <Col xs={12}>
              <Divider/>
              <h6 className={'mt-4'} style={{
                fontWeight: 'bold'
              }}>
                Gift Card Recipient
              </h6>

              <div style={{
                marginTop: '15px',
                width: '100%'
              }}>
                <MDInput type="text" required
                         variant="outlined"
                         InputLabelProps={{shrink: true}}
                         autoComplete="gift-card-recipient-name"
                         defaultValue={giftCardRecipientName}
                         onChange={(e) => {
                           setGiftCardRecipientName(e.target.value);
                         }}
                         className="form-control"
                         name="giftCardRecipientName"
                         id="giftCardRecipientName" aria-describedby="emailHelp"
                         label="Recipient name"
                         placeholder="First & Last Name"
                />
              </div>

              <div style={{
                marginTop: '15px',
                width: '100%'
              }}>
                <MDInput type="email" required
                         variant="outlined"
                         InputLabelProps={{shrink: true}}
                         autoComplete="gift-card-recipient-email"
                         defaultValue={giftCardRecipientEmail}
                         onChange={(e) => {
                           setGiftCardRecipientEmail(e.target.value);
                         }}
                         className="form-control"
                         name="giftCardRecipientEmail"
                         id="giftCardRecipientEmail" aria-describedby="emailHelp"
                         label="Recipient email"
                         placeholder="Email Address"
                />
              </div>

              <div style={{
                marginTop: '15px',
                width: '100%'
              }}>
                <h6 style={{
                  fontWeight: 'bold'
                }}>Message</h6>
                <textarea type="text"
                          defaultValue={giftCardRecipientMessage}
                          onChange={(e) => {
                            setGiftCardRecipientMessage(e.target.value);
                          }}
                          autoComplete="off"
                          maxLength={255}
                          name="giftCardRecipientMessage"
                          className="form-control" id="giftCardRecipientMessage"
                          placeholder="A Gift For You!"/>
                <p className={'text-small mt-1'}>
                  {250 - (giftCardRecipientMessage?.length || 0)} characters remaining
                </p>
              </div>

              <div style={{
                marginTop: '15px',
                width: '100%'
              }}>
                <h6 style={{
                  fontWeight: 'bold'
                }}>Future Gift? <Checkbox defaultChecked={false}
                                          onChange={(e) => {
                                            setGiftCardDeliverFuture(!giftCardDeliverFuture);
                                          }}
                                          name="giftCardDeliverFuture"
                                          id="giftCardDeliverFuture"/></h6>
                <p className={'font-small'} style={{
                  fontSize: 'smaller'
                }}>
                  Select future gift to send notification at a future date.
                </p>
                <div className="form-group">
                  <h6 style={{fontWeight: 'bold'}}>
                    <label htmlFor="billingEndDate">Delivery Date</label>
                  </h6>

                  <div className={'input-group d-block'}>
                    <DesktopDatePicker
                      disabled={!giftCardDeliverFuture}
                      slotProps={{
                        actionBar: {
                          actions: ['today', 'accept'],
                        },
                      }}
                      name={'giftCardRecipientSendDate'}
                      value={dayjs(giftCardRecipientSendDate)}
                      minDate={dayjs()}
                      onChange={(e) => {
                        setGiftCardRecipientSendDate(new Date(e.$d));
                        let _e = {
                          target: {
                            name: 'giftCardRecipientSendDate',
                            value: new Date(e.$d)
                          }
                        }
                        giftCardRecipientCallback(_e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>}

        </>
        }
      </>
      }

    </div>
  )
}